import { IconProps } from '@phosphor-icons/react';
import {
    Car,
    ForkKnife,
    Globe,
    GraduationCap,
    Heartbeat,
    ShoppingBag,
    Sparkle,
    Storefront,
    Briefcase,
    Wrench,
    Ticket
} from '@phosphor-icons/react';

export interface Industry {
  id: string;
  label: string;
  desc: string;
  icon: React.ComponentType<IconProps>;
}

export const INDUSTRY_STEP_TITLE = 'What industry are you in?';

export const INDUSTRY_STEP_SUBTITLE = 'This helps Bustly tailor your setup and show the most relevant ways it can support your business.';

export const INDUSTRIES: Industry[] = [
    {
        id: 'ecommerce',
        label: 'E-commerce',
        desc: 'Operate your store with more clarity and control',
        icon: ShoppingBag
    },
    {
        id: 'retail',
        label: 'Retail',
        desc: 'Keep stores, teams, and operations moving together',
        icon: Storefront
    },
    {
        id: 'restaurants',
        label: 'Restaurants',
        desc: 'Stay on top of service, demand, and daily operations',
        icon: ForkKnife
    },
    {
        id: 'fitness',
        label: 'Fitness',
        desc: 'Run your business with more consistency and momentum',
        icon: Heartbeat
    },
    {
        id: 'beauty',
        label: 'Beauty',
        desc: 'Keep appointments, clients, and growth on track',
        icon: Sparkle
    },
    {
        id: 'agencies',
        label: 'Agencies',
        desc: 'Bring more structure to delivery and client operations',
        icon: Briefcase
    },
    {
        id: 'home-services',
        label: 'Home Services',
        desc: 'Keep jobs, teams, and service running smoothly',
        icon: Wrench
    },
    {
        id: 'automotive',
        label: 'Automotive',
        desc: 'Run a more efficient and responsive service operation',
        icon: Car
    },
    {
        id: 'events',
        label: 'Events',
        desc: 'Keep planning, coordination, and execution aligned',
        icon: Ticket
    },
    {
        id: 'education',
        label: 'Education',
        desc: 'Support day-to-day operations with more consistency',
        icon: GraduationCap
    },
    {
        id: 'other',
        label: 'Other',
        desc: 'Shape Bustly around how your business operates',
        icon: Globe
    },
];
